import { getCookie, setCookie } from './cookie'

const INVITE_COOKIE_KEY = 'invite'
const INVITE_STORAGE_KEY = 'invite'
const INVITE_EXPIRE_DAYS = 7
const INVITE_LOG_PREFIX = '[invite]'

const normalizeQueryValue = (value) => {
  if (Array.isArray(value)) return value[0] || ''
  return value ? String(value) : ''
}

const getSearchParam = (search, key) => {
  if (!search) return ''
  try {
    return new URLSearchParams(search).get(key) || ''
  } catch (e) {
    return ''
  }
}

const getHashParam = (key) => {
  if (typeof window === 'undefined') return ''
  const hash = window.location.hash || ''
  const queryIndex = hash.indexOf('?')
  if (queryIndex === -1) return ''
  return getSearchParam(hash.slice(queryIndex), key)
}

const logInvite = (message, data = {}) => {
  if (typeof console === 'undefined') return
  console.log(INVITE_LOG_PREFIX, message, data)
}

const getStoredInvite = () => {
  if (typeof window === 'undefined') return ''
  try {
    return window.localStorage.getItem(INVITE_STORAGE_KEY) || ''
  } catch (e) {
    return ''
  }
}

const setStoredInvite = (invite) => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(INVITE_STORAGE_KEY, invite)
  } catch (e) {}
}

export const getInviteFromUrlInfo = (route) => {
  const routeInvite = normalizeQueryValue(route?.query?.invite).trim()
  if (routeInvite) return { invite: routeInvite, source: 'route.query.invite' }

  if (typeof window === 'undefined') return { invite: '', source: '' }

  const searchInvite = getSearchParam(window.location.search, 'invite').trim()
  if (searchInvite) return { invite: searchInvite, source: 'window.location.search' }

  const hashInvite = getHashParam('invite').trim()
  if (hashInvite) return { invite: hashInvite, source: 'window.location.hash' }

  return { invite: '', source: '' }
}

export const getInviteFromUrl = (route) => {
  return getInviteFromUrlInfo(route).invite
}

export const persistInviteFromUrl = (route, stage = '') => {
  const { invite, source } = getInviteFromUrlInfo(route)
  if (invite) {
    setCookie(INVITE_COOKIE_KEY, invite, INVITE_EXPIRE_DAYS)
    setStoredInvite(invite)
    logInvite('已从链接保存邀请码', {
      stage,
      source,
      invite,
      routeQuery: route?.query || {},
      href: typeof window !== 'undefined' ? window.location.href : ''
    })
  } else {
    logInvite('链接中未读取到邀请码', {
      stage,
      routeQuery: route?.query || {},
      search: typeof window !== 'undefined' ? window.location.search : '',
      hash: typeof window !== 'undefined' ? window.location.hash : ''
    })
  }
  return invite
}

export const getSavedInvite = (stage = '') => {
  const cookieInvite = getCookie(INVITE_COOKIE_KEY)
  const storageInvite = getStoredInvite()
  const invite = cookieInvite || storageInvite
  if (storageInvite && !cookieInvite) {
    setCookie(INVITE_COOKIE_KEY, storageInvite, INVITE_EXPIRE_DAYS)
  }
  logInvite('读取已保存邀请码', {
    stage,
    invite,
    cookieInvite,
    storageInvite
  })
  return invite
}
